angular.module('app.home.kpi')

.controller('HomeKPICtrl', function($scope, $rootScope, $http, $filter, filterFilter){
    
    $scope.$on('refreshDashboard', function(event, args) {
        loadData();
    });

    var loadData = function(){

        $scope.general = [
            {label: 'Impressions', value: null},
            {label: 'Reach', value:  null},
            {label: 'Engagement', value:  null},
            {label: 'Impact', value: null}
        ];

        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
                return;
        }
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

        var endpoint = $rootScope.apiUrl + 'home/getHomePageGlobalKPIs?' + $.param(params);
        $http.get(endpoint, {loader: false})
            .success(function(response){
                if (response.data !== null) {
                    $scope.noData = false;
                    $scope.general[0].value = response.data.impressions;
                    $scope.general[1].value = response.data.reach;
                    $scope.general[2].value = response.data.engagement;
                    $scope.general[3].value = response.data.impact;
                }
                else {
                    $scope.noData = true;
                }     
            });
    }

    loadData();
})
